import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { usePage } from '~/__modules__/page';

const rootElem = document.getElementById('modal-root');
const style = { overflowX: 'auto' };

Layer.propTypes = {
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  children: PropTypes.node.isRequired,
  customStyle: PropTypes.object,
};
export default function Layer({ className, children, customStyle = {} }) {
  const { language } = usePage();

  return ReactDOM.createPortal(
    <div
      className={classNames('ly_wrap', 'dimmed', language, {
        ua_win: navigator.platform.includes('Win'),
      })}
      style={{ ...style, ...customStyle }}
    >
      <div className={classNames('ly_common', className)}>{children}</div>
    </div>,
    rootElem,
  );
}
